<template>
    <main class="main">
        <div class="container-fluid px-0" data-layout="container">

            <aside-main/>

            <header-main/>

            <div class="content">

                <div class="card-header mb-5 d-flex flex-between-center">
                    <div class="d-flex align-items-center">
                        <h2>Главная</h2>
                    </div>
                </div>

                <div class="card-body p-0 spinner-center" v-if="preloader">
                    <div class="p-4 code-to-copy">
                        <div class="spinner-border" role="status"></div>
                    </div>
                </div>

                <div class="row g-5" v-if="!preloader">
                    <div class="col-xl-12 mb-5">
                        <form class="row g-3" v-on:submit.prevent="update">

                            <div class="col-sm-6 col-md-12">
                                <div class="form-floating">
                                    <input
                                        v-model="data.name"
                                        @input="errors.name = null"
                                        :class="{'is-invalid': errors.name}"
                                        placeholder="Имя"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Имя</label>
                                    <div class="invalid-feedback">{{errors.name}}</div>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input
                                        v-model="data.spending_month"
                                        @input="errors.spending_month = null"
                                        :class="{'is-invalid': errors.spending_month}"
                                        placeholder="Месяц"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Месяц</label>
                                    <div class="invalid-feedback">{{errors.spending_month}}</div>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input
                                        v-model="data.spending_month_value"
                                        @input="errors.spending_month_value = null"
                                        :class="{'is-invalid': errors.spending_month_value}"
                                        placeholder="Значение за месяц"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Значение за месяц</label>
                                    <div class="invalid-feedback">{{errors.spending_month_value}}</div>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input
                                        v-model="data.balance"
                                        @input="errors.balance = null"
                                        :class="{'is-invalid': errors.balance}"
                                        placeholder="Баланс"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Баланс</label>
                                    <div class="invalid-feedback">{{errors.balance}}</div>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input
                                        v-model="data.points"
                                        @input="errors.points = null"
                                        :class="{'is-invalid': errors.points}"
                                        placeholder="Баллы"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Баллы</label>
                                    <div class="invalid-feedback">{{errors.points}}</div>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input
                                        v-model="data.savings_balance"
                                        @input="errors.savings_balance = null"
                                        :class="{'is-invalid': errors.savings_balance}"
                                        placeholder="Накопительный счет"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Накопительный счет</label>
                                    <div class="invalid-feedback">{{errors.savings_balance}}</div>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input
                                        v-model="data.phones"
                                        @input="errors.phones = null"
                                        :class="{'is-invalid': errors.phones}"
                                        placeholder="Тинькофф Мобайл"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Тинькофф Мобайл</label>
                                    <div class="invalid-feedback">{{errors.phones}}</div>
                                </div>
                            </div>



                            <div class="card-header p-2 mt-4 d-flex flex-between-center" style="margin-bottom: -10px;">
                                <div class="d-flex align-items-center">
                                    <h2 class="fs-1">Оповещения</h2>
                                </div>
                            </div>

                            <div class="col-sm-3 col-md-3">
                                <div class="form-floating">
                                    <input
                                        v-model="data.notifications.home"
                                        placeholder="Главная"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Главная</label>
                                </div>
                            </div>

                            <div class="col-sm-3 col-md-3">
                                <div class="form-floating">
                                    <input
                                        v-model="data.notifications.payments"
                                        placeholder="Платежи"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Платежи</label>
                                </div>
                            </div>

                            <div class="col-sm-3 col-md-3">
                                <div class="form-floating">
                                    <input
                                        v-model="data.notifications.city"
                                        placeholder="Город"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Город</label>
                                </div>
                            </div>

                            <div class="col-sm-3 col-md-3">
                                <div class="form-floating">
                                    <input
                                        v-model="data.notifications.chat"
                                        placeholder="Чат"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Чат</label>
                                </div>
                            </div>



                            <div class="card-header p-2 mt-4 d-flex flex-between-center" style="margin-bottom: -10px;">
                                <div class="d-flex align-items-center">
                                    <h2 class="fs-1">Баннеры</h2>
                                </div>

                                <div class="d-flex">
                                    <a 
                                        @click="newBanner"
                                        class="btn btn-primary mb-1 float_right">Новый баннер</a>
                                </div>
                            </div>

                            <template v-for="(item, index) in data.images.banners">
                                <div class="col-sm-6 col-md-6">
                                    <div class="form-floating">
                                        <input
                                            v-model="data.images.banners[index].description"
                                            placeholder="Описание"
                                            class="form-control" 
                                            type="text"/>
                                        <label>Описание</label>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-6">
                                    <div class="form-floating v-select-medium select-both-button-row" :class="{'v-select-error': errors.images.banners[index].image}">
                                        <div 
                                            @click="$refs.uploadBanner.click()"
                                            content="Загрузить новое изображение" 
                                            v-tippy="{arrow : true, arrowType: 'round'}"
                                            class="select-button-left">
                                            <span class="vertical-center-icon">
                                                <i class="fa-solid fa-plus"></i>
                                            </span>
                                        </div>
                                        <div>
                                            <vue-select
                                                @input="errors.images.banners[index].image = null"
                                                v-model="data.images.banners[index].image"
                                                :options="utils.images.banners" 
                                                placeholder="Изображение">
                                                <template v-slot:option="option">
                                                    <img style="width: 100px;margin-right: 20px;height: 100%;" :src="`${$config.ApplicationPublicURL}/img/tinkoff/home/banners/${option.label}`"/>
                                                    <a 
                                                        @click="deleteImageBanners(option.label)"
                                                        content="Удалить" 
                                                        v-tippy="{arrow : true, arrowType: 'round'}"
                                                        class="btn btn-sm btn-soft-danger ms-2" 
                                                        style="position: absolute; right: 1rem;">
                                                        <i class="fa-regular fa-trash"></i>
                                                    </a>
                                                </template>
                                                <template v-slot:no-options="{ search, searching }">
                                                  <template v-if="searching">
                                                     Ничего не найдено по запросу <em>{{ search }}</em>.
                                                  </template>
                                                </template>
                                            </vue-select>
                                            <label class="custom-select-label">Изображение</label>
                                        </div>

                                        <button
                                            @click="changeBannerStatus(index)"
                                            :content="data.images.banners[index].status == 1 ? 'Отключить' : 'Включить'" 
                                            v-tippy="{arrow : true, arrowType: 'round'}"
                                            type="button"
                                            class="btn btn-soft-secondary select-button-right">
                                            <span class="vertical-center-icon">
                                                <i class="icon-paysystem fa-regular" :class="{'fa-circle-pause': data.images.banners[index].status == 1, 'fa-play': data.images.banners[index].status == 0}"></i>
                                            </span>
                                        </button>

                                        <button
                                            :disabled="data.images.banners.length == 1"
                                            @click="deleteBanner(index)"
                                            content="Удалить" 
                                            v-tippy="{arrow : true, arrowType: 'round'}"
                                            type="button"
                                            class="btn btn-soft-danger select-button-right-2">
                                            <span class="vertical-center-icon">
                                                <i class="icon-paysystem fa-regular fa-trash"></i>
                                            </span>
                                        </button>
                                    </div>
                                    <div class="invalid-feedback" v-if="errors.images.banners[index].image">{{errors.images.banners[index].image}}</div>
                                </div>
                            </template>

                            <input ref="uploadBanner" type="file" @input="uploadImageBanners" accept=".png, .jpg, .jpeg, .gif, .svg" style="display: none;">



                            <div class="card-header p-2 mt-4 d-flex flex-between-center" style="margin-bottom: -10px;">
                                <div class="d-flex align-items-center">
                                    <h2 class="fs-1">Кэшбэк и бонусы</h2>
                                </div>

                                <div class="d-flex">
                                    <a 
                                        @click="newCashback"
                                        class="btn btn-primary mb-1 float_right">Новый кэшбэк</a>
                                </div>
                            </div>

                            <template v-for="(item, index) in data.images.cashback">
                                <div class="col-sm-6 col-md-12">
                                    <div class="form-floating v-select-medium select-both-button-row" :class="{'v-select-error': errors.images.cashback[index].image}">
                                        <div 
                                            @click="$refs.uploadСashback.click()"
                                            content="Загрузить новое изображение" 
                                            v-tippy="{arrow : true, arrowType: 'round'}"
                                            class="select-button-left">
                                            <span class="vertical-center-icon">
                                                <i class="fa-solid fa-plus"></i>
                                            </span>
                                        </div>
                                        <div>
                                            <vue-select
                                                @input="errors.images.cashback[index].image = null"
                                                v-model="data.images.cashback[index].image"
                                                :options="utils.images.cashback" 
                                                placeholder="Изображение">
                                                <template v-slot:option="option">
                                                    <img style="width: 100px;margin-right: 20px;height: 100%;" :src="`${$config.ApplicationPublicURL}/img/tinkoff/home/cashback/${option.label}`"/>
                                                    <a 
                                                        @click="deleteImageCashback(option.label)"
                                                        content="Удалить" 
                                                        v-tippy="{arrow : true, arrowType: 'round'}"
                                                        class="btn btn-sm btn-soft-danger ms-2" 
                                                        style="position: absolute; right: 1rem;">
                                                        <i class="fa-regular fa-trash"></i>
                                                    </a>
                                                </template>
                                                <template v-slot:no-options="{ search, searching }">
                                                  <template v-if="searching">
                                                     Ничего не найдено по запросу <em>{{ search }}</em>.
                                                  </template>
                                                </template>
                                            </vue-select>
                                            <label class="custom-select-label">Изображение</label>
                                        </div>

                                        <button
                                            @click="changeCashbackStatus(index)"
                                            :content="data.images.cashback[index].status == 1 ? 'Отключить' : 'Включить'" 
                                            v-tippy="{arrow : true, arrowType: 'round'}"
                                            type="button"
                                            class="btn btn-soft-secondary select-button-right">
                                            <span class="vertical-center-icon">
                                                <i class="icon-paysystem fa-regular" :class="{'fa-circle-pause': data.images.cashback[index].status == 1, 'fa-play': data.images.cashback[index].status == 0}"></i>
                                            </span>
                                        </button>

                                        <button
                                            :disabled="data.images.cashback.length == 1"
                                            @click="deleteCashback(index)"
                                            content="Удалить" 
                                            v-tippy="{arrow : true, arrowType: 'round'}"
                                            type="button"
                                            class="btn btn-soft-danger select-button-right-2">
                                            <span class="vertical-center-icon">
                                                <i class="icon-paysystem fa-regular fa-trash"></i>
                                            </span>
                                        </button>
                                    </div>
                                    <div class="invalid-feedback" v-if="errors.images.cashback[index].image">{{errors.images.cashback[index].image}}</div>
                                </div>
                            </template>

                            <input ref="uploadСashback" type="file" @input="uploadImageCashback" accept=".png, .jpg, .jpeg, .gif, .svg" style="display: none;">


                            <div class="card-header p-2 mt-4 d-flex flex-between-center" style="margin-bottom: -10px;">
                                <div class="d-flex align-items-center">
                                    <h2 class="fs-1">Нижний баннер</h2>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-12">
                                <div class="form-floating v-select-medium select-both-button-row" :class="{'v-select-error': errors.images.bottom.image}">
                                    <div 
                                        @click="$refs.uploadBottom.click()"
                                        content="Загрузить новое изображение" 
                                        v-tippy="{arrow : true, arrowType: 'round'}"
                                        class="select-button-left">
                                        <span class="vertical-center-icon">
                                            <i class="fa-solid fa-plus"></i>
                                        </span>
                                    </div>
                                    <div>
                                        <vue-select
                                            @input="errors.images.bottom.image = null"
                                            v-model="data.images.bottom.image"
                                            :options="utils.images.bottom" 
                                            placeholder="Изображение">
                                            <template v-slot:option="option">
                                                <img style="width: 130px;margin-right: 20px;height: 100%;" :src="`${$config.ApplicationPublicURL}/img/tinkoff/home/bottom/${option.label}`"/>
                                                <a 
                                                    @click="deleteImageBottom(option.label)"
                                                    content="Удалить" 
                                                    v-tippy="{arrow : true, arrowType: 'round'}"
                                                    class="btn btn-sm btn-soft-danger ms-2" 
                                                    style="position: absolute; right: 1rem;">
                                                    <i class="fa-regular fa-trash"></i>
                                                </a>
                                            </template>
                                            <template v-slot:no-options="{ search, searching }">
                                              <template v-if="searching">
                                                 Ничего не найдено по запросу <em>{{ search }}</em>.
                                              </template>
                                            </template>
                                        </vue-select>
                                        <label class="custom-select-label">Изображение</label>
                                    </div>

                                    <button
                                        @click="changeBottomStatus"
                                        :content="data.images.bottom.status == 1 ? 'Отключить' : 'Включить'" 
                                        v-tippy="{arrow : true, arrowType: 'round'}"
                                        type="button"
                                        class="btn btn-soft-secondary select-button-right">
                                        <span class="vertical-center-icon">
                                            <i class="icon-paysystem fa-regular" :class="{'fa-circle-pause': data.images.bottom.status == 1, 'fa-play': data.images.bottom.status == 0}"></i>
                                        </span>
                                    </button>

                                    <button
                                        :disabled="true"
                                        content="Удалить" 
                                        v-tippy="{arrow : true, arrowType: 'round'}"
                                        type="button"
                                        class="btn btn-soft-danger select-button-right-2">
                                        <span class="vertical-center-icon">
                                            <i class="icon-paysystem fa-regular fa-trash"></i>
                                        </span>
                                    </button>
                                </div>
                                <div class="invalid-feedback" v-if="errors.images.bottom.image">{{errors.images.bottom.image}}</div>
                            </div>

                            <input ref="uploadBottom" type="file" @input="uploadImageBottom" accept=".png, .jpg, .jpeg, .gif, .svg" style="display: none;">




                            <div class="card-header p-2 mt-4 d-flex flex-between-center" style="margin-bottom: -10px;">
                                <div class="d-flex align-items-center">
                                    <h2 class="fs-1">Карты</h2>
                                </div>

                                <div class="d-flex">
                                    <a 
                                        @click="newCard"
                                        class="btn btn-primary mb-1 float_right">Новая карта</a>
                                </div>
                            </div>

                            <template v-for="(item, index) in data.cards">
                                <div class="col-sm-6 col-md-6">
                                    <div class="form-floating">
                                        <input
                                            v-model="data.cards[index].number"
                                            @input="errors.cards[index].number = null"
                                            :class="{'is-invalid': errors.cards[index].number}"
                                            placeholder="Последние 4 цифры"
                                            class="form-control" 
                                            type="text"/>
                                        <label>Последние 4 цифры</label>
                                        <div class="invalid-feedback">{{errors.cards[index].number}}}</div>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-6">
                                    <div class="form-floating v-select-medium select-both-button-row" :class="{'v-select-error': errors.cards[index].type}">
                                        <div class="select-button-left">
                                            <span class="vertical-center-icon">
                                                <i class="fa-solid fa-credit-card"></i>
                                            </span>
                                        </div>
                                        <div>
                                            <vue-select
                                                @input="errors.cards[index].type = null"
                                                v-model="data.cards[index].type"
                                                :options="utils.cards"
                                                label="name"
                                                placeholder="Тип карты">
                                                <template v-slot:no-options="{ search, searching }">
                                                  <template v-if="searching">
                                                     Ничего не найдено по запросу <em>{{ search }}</em>.
                                                  </template>
                                                </template>
                                            </vue-select>
                                            <label class="custom-select-label">Тип карты</label>
                                        </div>

                                        <button
                                            @click="changeCardStatus(index)"
                                            :content="data.cards[index].status == 1 ? 'Отключить' : 'Включить'" 
                                            v-tippy="{arrow : true, arrowType: 'round'}"
                                            type="button"
                                            class="btn btn-soft-secondary select-button-right">
                                            <span class="vertical-center-icon">
                                                <i class="icon-paysystem fa-regular" :class="{'fa-circle-pause': data.cards[index].status == 1, 'fa-play': data.cards[index].status == 0}"></i>
                                            </span>
                                        </button>

                                        <button
                                            :disabled="data.cards.length == 1"
                                            @click="deleteCard(index)"
                                            content="Удалить" 
                                            v-tippy="{arrow : true, arrowType: 'round'}"
                                            type="button"
                                            class="btn btn-soft-danger select-button-right-2">
                                            <span class="vertical-center-icon">
                                                <i class="icon-paysystem fa-regular fa-trash"></i>
                                            </span>
                                        </button>
                                    </div>
                                    <div class="invalid-feedback" v-if="errors.cards[index].type">{{errors.cards[index].type}}</div>
                                </div>
                            </template>


                            <div class="col-sm-3 col-md-3">
                                <button class="btn btn-primary px-5 w-100 text-nowrap" type="submit" :class="{'disabled': btn_preloader}">
                                    <span class="spinner-border spinner-border-sm spinner-border-custom" role="status" v-if="btn_preloader"></span>
                                    <span>Сохранить</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                
                <footer-main/>

            </div>

        </div>
    </main>
</template>

<script>
export default {
    props: ['id'],
    data () {
        return {
            preloader: true,
            btn_preloader: false,
            data: {
                name: null,
                images: {
                    banners: [{
                        image: null,
                        description: null,
                        status: 1
                    }],
                    cashback: [{
                        image: null,
                        status: 1
                    }],
                    bottom: {
                        image: null,
                        status: 1
                    }
                },
                spending_month: null,
                spending_month_value: null,
                balance: null,
                points: null,
                cards: [
                    {
                        number: null,
                        type: {
                            name: 'Visa',
                            key: 'visa'
                        },
                        status: 1
                    }
                ],
                savings_balance: null,
                phones: null,

                notifications: {
                    home: null,
                    payments: null,
                    city: null,
                    chat: null
                }
            },
            errors: {
                name: false,
                images: {
                    banners: [
                        {
                            image: false,
                            description: false,
                            status: false
                        }
                    ],
                    cashback: [
                        {
                            image: false,
                            status: false
                        }
                    ],
                    bottom: {
                        image: false,
                        status: false
                    }
                },
                spending_month: false,
                spending_month_value: false,
                balance: false,
                points: false,
                cards: [
                    {
                        number: false,
                        type: false
                    }
                ],
                savings_balance: false,
                phones: false
            },
            utils: {
                images: {
                    banners: [],
                    cashback: [],
                    bottom: []
                },
                cards: [
                    {
                        name: 'Visa',
                        key: 'visa'
                    },
                    {
                        name: 'MasterCard',
                        key: 'mastercard'
                    },
                    {
                        name: 'Maestro',
                        key: 'maestro'
                    },
                    {
                        name: 'Мир',
                        key: 'mir'
                    }
                ]
            }
        }
    },
    methods: {
        getItem () {
            this.$axios.post('/tinkoff_new/item/home')
            .then(async (response) => {
                this.preloader = false
                response = response.data
                switch (response.status) {
                    case 'error':
                        this.$toast.error(response.message)
                        break
                    case 'success':

                        for(let banner of response.data.images.banners) {
                            this.errors.images.banners.push({
                                image: false,
                                description: false
                            })
                        }

                        for(let banner of response.data.images.cashback) {
                            this.errors.images.cashback.push({
                                image: false
                            })
                        }

                        for(let banner of response.data.cards) {
                            this.errors.cards.push({
                                number: false,
                                type: false
                            })
                        }

                        this.data = response.data

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })     
        },
        update () {
            this.btn_preloader = true
            this.$axios.post('/tinkoff_new/home/update', JSON.stringify(this.data))
            .then((response) => {
                this.btn_preloader = false
                response = response.data
                switch (response.status) {
                    case "error":
                        this.$toast.error(response.message)
                        break
                    case "success":
                        this.$toast.success(response.message)

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                this.btn_preloader = false
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    if('field' in response) {
                        this.errorByPatch(this.errors, response.field, response.message)
                    } else {
                        this.$toast.error(response.message)
                    }
                }
            })
        },
        getImagesBanners () {
            this.$axios.post('/tinkoff_new/home/images/banners/items')
            .then((response) => {
                response = response.data
                switch (response.status) {
                    case 'error':
                        this.$toast.error(response.message)
                        break
                    case 'success':
                        this.utils.images.banners = response.data

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })     
        },
        getImagesCashback () {
            this.$axios.post('/tinkoff_new/home/images/cashback/items')
            .then((response) => {
                response = response.data
                switch (response.status) {
                    case 'error':
                        this.$toast.error(response.message)
                        break
                    case 'success':
                        this.utils.images.cashback = response.data

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })     
        },
        getImagesBottom () {
            this.$axios.post('/tinkoff_new/home/images/bottom/items')
            .then((response) => {
                response = response.data
                switch (response.status) {
                    case 'error':
                        this.$toast.error(response.message)
                        break
                    case 'success':
                        this.utils.images.bottom = response.data

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })     
        },
        uploadImageBanners (e) {
            var formData = new FormData()
            formData.append("image", e.target.files[0])

            this.$confirm('Вы уверены что хотите загрузить это изображение?').then(() => {
                this.$axios.post('/tinkoff_new/home/images/banners/upload', formData)
                .then((response) => {
                    response = response.data
                    switch (response.status) {
                        case 'error':
                            this.$toast.error(response.message)
                            break
                        case 'success':
                            this.getImagesBanners()
                            this.$toast.success(response.message)

                            this.setUser(response.user)
                            break
                        default:
                            this.$toast.error('Unknown error')
                    }
                }).catch((error) => {
                    let response = error.response.data
                    this.setUser(response.user)

                    if('status' in response && response.status == 'error') {
                        this.$toast.error(response.message)
                    }
                })  
            })
        },
        uploadImageCashback (e) {
            var formData = new FormData()
            formData.append("image", e.target.files[0])

            this.$confirm('Вы уверены что хотите загрузить это изображение?').then(() => {
                this.$axios.post('/tinkoff_new/home/images/cashback/upload', formData)
                .then((response) => {
                    response = response.data
                    switch (response.status) {
                        case 'error':
                            this.$toast.error(response.message)
                            break
                        case 'success':
                            this.getImagesCashback()
                            this.$toast.success(response.message)

                            this.setUser(response.user)
                            break
                        default:
                            this.$toast.error('Unknown error')
                    }
                }).catch((error) => {
                    let response = error.response.data
                    this.setUser(response.user)

                    if('status' in response && response.status == 'error') {
                        this.$toast.error(response.message)
                    }
                })  
            })
        },
        uploadImageBottom (e) {
            var formData = new FormData()
            formData.append("image", e.target.files[0])

            this.$confirm('Вы уверены что хотите загрузить это изображение?').then(() => {
                this.$axios.post('/tinkoff_new/home/images/bottom/upload', formData)
                .then((response) => {
                    response = response.data
                    switch (response.status) {
                        case 'error':
                            this.$toast.error(response.message)
                            break
                        case 'success':
                            this.getImagesBottom()
                            this.$toast.success(response.message)

                            this.setUser(response.user)
                            break
                        default:
                            this.$toast.error('Unknown error')
                    }
                }).catch((error) => {
                    let response = error.response.data
                    this.setUser(response.user)

                    if('status' in response && response.status == 'error') {
                        this.$toast.error(response.message)
                    }
                })  
            })
        },
        deleteImageBanners (image) {
            this.$confirm('Вы уверены что хотите удалить это изображение?').then(() => {
                this.$axios.post('/tinkoff_new/home/images/banners/delete', JSON.stringify({
                    image: image
                }))
                .then((response) => {
                    response = response.data
                    switch (response.status) {
                        case 'error':
                            this.$toast.error(response.message)
                            break
                        case 'success':
                            this.getImagesBanners()
                            this.$toast.success(response.message)

                            this.setUser(response.user)
                            break
                        default:
                            this.$toast.error('Unknown error')
                    }
                }).catch((error) => {
                    let response = error.response.data
                    this.setUser(response.user)

                    if('status' in response && response.status == 'error') {
                        this.$toast.error(response.message)
                    }
                })  
            })
        },
        deleteImageCashback (image) {
            this.$confirm('Вы уверены что хотите удалить это изображение?').then(() => {
                this.$axios.post('/tinkoff_new/home/images/cashback/delete', JSON.stringify({
                    image: image
                }))
                .then((response) => {
                    response = response.data
                    switch (response.status) {
                        case 'error':
                            this.$toast.error(response.message)
                            break
                        case 'success':
                            this.getImagesCashback()
                            this.$toast.success(response.message)

                            this.setUser(response.user)
                            break
                        default:
                            this.$toast.error('Unknown error')
                    }
                }).catch((error) => {
                    let response = error.response.data
                    this.setUser(response.user)

                    if('status' in response && response.status == 'error') {
                        this.$toast.error(response.message)
                    }
                })  
            })
        },
        deleteImageBottom (image) {
            this.$confirm('Вы уверены что хотите удалить это изображение?').then(() => {
                this.$axios.post('/tinkoff_new/home/images/bottom/delete', JSON.stringify({
                    image: image
                }))
                .then((response) => {
                    response = response.data
                    switch (response.status) {
                        case 'error':
                            this.$toast.error(response.message)
                            break
                        case 'success':
                            this.getImagesBottom()
                            this.$toast.success(response.message)

                            this.setUser(response.user)
                            break
                        default:
                            this.$toast.error('Unknown error')
                    }
                }).catch((error) => {
                    let response = error.response.data
                    this.setUser(response.user)

                    if('status' in response && response.status == 'error') {
                        this.$toast.error(response.message)
                    }
                })  
            })
        },
        errorByPatch (layer, path, value) {
            path = path.split('.')

            path.forEach((value, index) => {
                if (!isNaN(value)) {
                    path[index] = parseInt(value)
                }
            })

            for (var i = 0; i < path.length; i++) {
                if (value != null && i + 1 === path.length) {
                    layer[path[i]] = value
                }
                layer = layer[path[i]]
            }
            return layer
        },
        newBanner () {
            this.data.images.banners.push({
                image: null,
                description: null,
                status: 1
            })

            this.errors.images.banners.push({
                image: false,
                description: false
            })
        },
        newCashback () {
            this.data.images.cashback.push({
                image: null,
                status: 1
            })

            this.errors.images.cashback.push({
                image: false
            })
        },
        deleteBanner (index) {
            if(this.data.images.banners.length > 1) {
                this.data.images.banners.splice(index, 1)
            }
        },
        deleteCashback (index) {
            if(this.data.images.cashback.length > 1) {
                this.data.images.cashback.splice(index, 1)
            }
        },
        changeBannerStatus (index) {
            this.data.images.banners[index].status = this.data.images.banners[index].status ? 0 : 1
        },
        changeCashbackStatus (index) {
            this.data.images.cashback[index].status = this.data.images.cashback[index].status ? 0 : 1
        },
        changeBottomStatus () {
            this.data.images.bottom.status = this.data.images.bottom.status ? 0 : 1
        },


        newCard () {
            this.data.cards.push({
                number: null,
                type: 'visa',
                status: 1
            })

            this.errors.cards.push({
                number: false,
                type: false
            })
        },
        deleteCard (index) {
            if(this.data.cards.length > 1) {
                this.data.cards.splice(index, 1)
            }
        },
        changeCardStatus (index) {
            this.data.cards[index].status = this.data.cards[index].status ? 0 : 1
        },
    },
    beforeMount() {
        this.getItem()
        this.getImagesBanners()
        this.getImagesCashback()
        this.getImagesBottom()
    }
}
</script>

<style lang="css" scoped>
    ::v-deep .vs__clear {
        display: none;
    }
</style>
